module.exports = __webpack_public_path__ + "static/media/conju.b239eab4.png";